import { scorePercent } from '../utils/targetScoreIntegrity';
import React, { useRef, useEffect } from 'react';
import { Box } from '@material-ui/core';
import NavBar from '../components/NavBar';
import Typography from '@material-ui/core/Typography';
import { Divider } from '@material-ui/core';
import { getResponse } from '../utils/getResponse';
import Grid from '@material-ui/core/Grid';
import Progress from '@material-ui/core/LinearProgress';
//import { format } from 'date-fns';
import ResultFeedback from '../components/resultFeedback.json';
import { Bar, Radar } from 'react-chartjs-2';
import Footer from '../components/Footer';
import Button from '@material-ui/core/Button';
import ReactToPrint from 'react-to-print';
import { Link } from 'react-router-dom';
import { isMobile } from '../utils/util';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

function ResultExtended(props) {
  const componentRef = useRef();
  //store data of MotivationAtWork
  const [MotivationAtWorkIntrinsic, setMotivationAtWorkIntrinsic] =
    React.useState(0);
  const [MotivationAtWorkIdentified, setMotivationAtWorkIdentified] =
    React.useState(0);
  const [MotivationAtWorkIntrojected, setMotivationAtWorkIntrojected] =
    React.useState(0);
  const [
    MotivationAtWorkExternalMotivation,
    setMotivationAtWorkExternalMotivation,
  ] = React.useState(0);
  //store data of EntrepreneurialPassion
  const [EntrepreneurialPassionInventing, setEntrepreneurialPassionInventing] =
    React.useState(0);
  const [EntrepreneurialPassionFounding, setEntrepreneurialPassionFounding] =
    React.useState(0);
  const [
    EntrepreneurialPassionDeveloping,
    setEntrepreneurialPassionDeveloping,
  ] = React.useState(0);
  //store data of IndividualEntrepreneurialOrientation
  const [
    IndividualEntrepreneurialOrientationRiskTaking,
    setIndividualEntrepreneurialOrientationRiskTaking,
  ] = React.useState(0);
  const [
    IndividualEntrepreneurialOrientationInnovativeness,
    setIndividualEntrepreneurialOrientationInnovativeness,
  ] = React.useState(0);
  const [
    IndividualEntrepreneurialOrientationProactivity,
    setIndividualEntrepreneurialOrientationProactivity,
  ] = React.useState(0);
  // //store data of EntrepreneurialSelfEfficacy
  const [
    EntrepreneurialSelfEfficacySearching,
    setEntrepreneurialSelfEfficacySearching,
  ] = React.useState(0);
  const [
    EntrepreneurialSelfEfficacyPlanning,
    setEntrepreneurialSelfEfficacyPlanning,
  ] = React.useState(0);
  const [
    EntrepreneurialSelfEfficacyMarshaling,
    setEntrepreneurialSelfEfficacyMarshaling,
  ] = React.useState(0);
  const [
    EntrepreneurialSelfEfficacyImplementingPeople,
    setEntrepreneurialSelfEfficacyImplementingPeople,
  ] = React.useState(0);
  const [
    EntrepreneurialSelfEfficacyImplementingFinancial,
    setEntrepreneurialSelfEfficacyImplementingFinancial,
  ] = React.useState(0);
  // //store data of FearOfFailure
  const [
    FearOfFailureAbilityToFundTheVenture,
    setFearOfFailureAbilityToFundTheVenture,
  ] = React.useState(0);
  const [FearOfFailurePotentialOfTheIdea, setFearOfFailurePotentialOfTheIdea] =
    React.useState(0);
  const [
    FearOfFailureThreatToSocialEsteem,
    setFearOfFailureThreatToSocialEsteem,
  ] = React.useState(0);
  const [FearOfFailureOpportunityCosts, setFearOfFailureOpportunityCosts] =
    React.useState(0);
  const [FearOfFailurePersonalAbility, setFearOfFailurePersonalAbility] =
    React.useState(0);
  const [FearOfFailureFinancialSecurity, setFearOfFailureFinancialSecurity] =
    React.useState(0);
  const [FearOfFailureVenturesCapacity, setFearOfFailureVenturesCapacity] =
    React.useState(0);
  // //store data of TheBigFive
  const [TheBigFiveExtraversion, setTheBigFiveExtraversion] = React.useState(0);
  const [TheBigFiveAgreeableness, setTheBigFiveAgreeableness] =
    React.useState(0);
  const [TheBigFiveConscientiousness, setTheBigFiveConscientiousness] =
    React.useState(0);
  const [TheBigFiveNeuroticism, setTheBigFiveNeuroticism] = React.useState(0);
  const [TheBigFiveOpenness, setTheBigFiveOpenness] = React.useState(0);
  // Growth Orientation
  const [GrowthOrientationValue, setGrowthOrientationValue] = React.useState(0);
  // Growth Mindset
  const [GrowthMindsetValue, setGrowthMindsetValue] = React.useState(0);
  // Cognitive Flexibility
  const [CognitiveFlexibilityValue, setCognitiveFlexibilityValue] = React.useState(0);
  // Grit
  const [GritValue, setGritValue] = React.useState(0);
  // Resilience
  const [ResilienceValue, setResilienceValue] = React.useState(0);
  // store RuleBreaking data
  const [RuleBreakingValue, setRuleBreakingValue] = React.useState(0);
  // Empathy
  const [EmpathyValue, setEmpathyValue] = React.useState(0);
  //Need To Achieve
  const [NeedToAchieveValue, setNeedToAchieveValue] = React.useState(0);
  //Imposter Syndrome
  const [ImposterSyndromeValue, setImposterSyndromeValue] = React.useState(0);
  // Tolerate Ambiguity
  const [ToleranceForAmbiguityValue, setToleranceForAmbiguityValue] =
  React.useState(0);
  // store Curiosity data
  const [CuriosityJoyousExploration, setCuriosityJoyousExploration] =
  React.useState(0);
  const [CuriosityDeprivationSensitivity, setCuriosityDeprivationSensitivity] =
  React.useState(0);
  const [CuriosityStressTolerance, setCuriosityStressTolerance] = React.useState(0);
  const [CuriosityThrillSeeking, setCuriosityThrillSeeking] = React.useState(0);
  const [CuriosityOvertSocial, setCuriosityOvertSocial] = React.useState(0);
  const [CuriosityCovertSocial, setCuriosityCovertSocial] = React.useState(0);
  // Passion scale constants
  const [HarmoniousPassionValue, setHarmoniousPassionValue] = React.useState(0);
  const [ObsessivePassionValue, setObsessivePassionValue] = React.useState(0);

  const [benchmarkAvailable, setBenchmarkAvailable] = React.useState(false);
  useEffect(() => {
    let cancelled = false;
    fetch('/api/results/benchmarks', { credentials: 'include' })
      .then(response => response.ok ? response.json() : null)
      .then(data => {
        if (cancelled || !data || !data.resultSet) return;
        const mappings = [
          ["MotivationAtWork.Intrinsic", setMotivationAtWorkIntrinsic],
          ["MotivationAtWork.Identified", setMotivationAtWorkIdentified],
          ["MotivationAtWork.Introjected", setMotivationAtWorkIntrojected],
          ["MotivationAtWork.ExternalMotivation", setMotivationAtWorkExternalMotivation],
          ["EntrepreneurialPassion.Inventing", setEntrepreneurialPassionInventing],
          ["EntrepreneurialPassion.Founding", setEntrepreneurialPassionFounding],
          ["EntrepreneurialPassion.Developing", setEntrepreneurialPassionDeveloping],
          ["IndividualEntrepreneurialOrientation.RiskTaking", setIndividualEntrepreneurialOrientationRiskTaking],
          ["IndividualEntrepreneurialOrientation.Innovativeness", setIndividualEntrepreneurialOrientationInnovativeness],
          ["IndividualEntrepreneurialOrientation.Proactivity", setIndividualEntrepreneurialOrientationProactivity],
          ["EntrepreneurialSelfEfficacy.Searching", setEntrepreneurialSelfEfficacySearching],
          ["EntrepreneurialSelfEfficacy.Planning", setEntrepreneurialSelfEfficacyPlanning],
          ["EntrepreneurialSelfEfficacy.Marshaling", setEntrepreneurialSelfEfficacyMarshaling],
          ["EntrepreneurialSelfEfficacy.ImplementingPeople", setEntrepreneurialSelfEfficacyImplementingPeople],
          ["EntrepreneurialSelfEfficacy.ImplementingFinancial", setEntrepreneurialSelfEfficacyImplementingFinancial],
          ["FearOfFailure.AbilityToFundTheVenture", setFearOfFailureAbilityToFundTheVenture],
          ["FearOfFailure.PotentialOfTheIdea", setFearOfFailurePotentialOfTheIdea],
          ["FearOfFailure.ThreatToSocialEsteem", setFearOfFailureThreatToSocialEsteem],
          ["FearOfFailure.OpportunityCosts", setFearOfFailureOpportunityCosts],
          ["FearOfFailure.PersonalAbility", setFearOfFailurePersonalAbility],
          ["FearOfFailure.FinancialSecurity", setFearOfFailureFinancialSecurity],
          ["FearOfFailure.VenturesCapacity", setFearOfFailureVenturesCapacity],
          ["TheBigFive.Extraversion", setTheBigFiveExtraversion],
          ["TheBigFive.Agreeableness", setTheBigFiveAgreeableness],
          ["TheBigFive.Conscientiousness", setTheBigFiveConscientiousness],
          ["TheBigFive.Neuroticism", setTheBigFiveNeuroticism],
          ["TheBigFive.Openness", setTheBigFiveOpenness],
          ["Curiosity.JoyousExploration", setCuriosityJoyousExploration],
          ["Curiosity.DeprivationSensitivity", setCuriosityDeprivationSensitivity],
          ["Curiosity.StressTolerance", setCuriosityStressTolerance],
          ["Curiosity.ThrillSeeking", setCuriosityThrillSeeking],
          ["Curiosity.OvertSocial", setCuriosityOvertSocial],
          ["Curiosity.CovertSocial", setCuriosityCovertSocial],
          ["GrowthOrientation.Total", setGrowthOrientationValue],
          ["GrowthMindset.Total", setGrowthMindsetValue],
          ["CognitiveFlexibility.Total", setCognitiveFlexibilityValue],
          ["Grit.Total", setGritValue],
          ["Resilience.Total", setResilienceValue],
          ["RuleBreaking.Total", setRuleBreakingValue],
          ["Empathy.Total", setEmpathyValue],
          ["NeedToAchieve.Total", setNeedToAchieveValue],
          ["ImposterSyndrome.Total", setImposterSyndromeValue],
          ["ToleranceForAmbiguity.Total", setToleranceForAmbiguityValue]
        ];
        const values = mappings.map(([metric, setter]) => {
          const value = metric.split('.').reduce((part,key) => part && part[key], data.resultSet);
          if (typeof value === 'number' && Number.isFinite(value)) { setter(value); return true; }
          return false;
        });
        setBenchmarkAvailable(values.every(Boolean));
      }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  const withAvailableBenchmark = data => ({ ...data, datasets: data.datasets.filter(dataset => benchmarkAvailable || dataset.label !== 'Average Entremap User') });

  let resultSet = props.location.state.resultSet;

  function SectionProgress(props) {
    return (
      <div>
        <Typography
          variant="h5"
          style={{
            paddingTop: '10px',
            paddingBottom: '10px',
            textAlign: 'center',
          }}
        >
          {props.name}
        </Typography>
        <Progress
          variant="determinate"
          value={props.value}
          style={{ height: '10px', maxWidth: '300px', margin: 'auto' }}
        />
      </div>
    );
  }

  // Chart.js data and options for measures below
  // See chart.js API for more modifications
  let MaWdata = {
    labels: ["Intrinsic", "Identified", "Introjected", "External Motivation"],
    datasets: [
      {
        label: "My Data",
        data: [
          scorePercent(resultSet.MotivationAtWork.Intrinsic, ResultFeedback.MotivationAtWork.Intrinsic.scale.max),
          scorePercent(resultSet.MotivationAtWork.Identified, ResultFeedback.MotivationAtWork.Identified.scale.max),
          scorePercent(resultSet.MotivationAtWork.Introjected, ResultFeedback.MotivationAtWork.Introjected.scale.max),
          scorePercent(resultSet.MotivationAtWork.ExternalMotivation, ResultFeedback.MotivationAtWork.ExternalMotivation.scale.max),
        ],
        backgroundColor: [
          "rgb(220,146,57)",
          "rgb(220,140,42)",
          "rgb(220,132,36)",
          "rgb(219,125,21)",
        ],
        borderColor: [isMobile ? "#fff" :"rgb(217, 98, 48)"],
        borderWidth: 1,
      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(MotivationAtWorkIntrinsic, ResultFeedback.MotivationAtWork.Intrinsic.scale.max),
          scorePercent(MotivationAtWorkIdentified, ResultFeedback.MotivationAtWork.Identified.scale.max),
          scorePercent(MotivationAtWorkIntrojected, ResultFeedback.MotivationAtWork.Introjected.scale.max),
          scorePercent(MotivationAtWorkExternalMotivation, ResultFeedback.MotivationAtWork.ExternalMotivation.scale.max),
        ],
        backgroundColor: ["rgba(74, 73, 72, 0.7)"],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
      },
    ],
  };

  let MaWoptions = {
    scales: {
      xAxes: {
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        },
        ticks: isMobile
          ? {
              font: {
                size: 9,
              },
              color: "#ffffff",
            }
          : {
              font: {
                size: 9,
              },
            },
      },
      yAxes: {
        beginAtZero: true,
        max: 100,
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        },
        ticks: isMobile
          ? {
              color: "#ffffff",
            }
          : {},
      },
    },
    plugins: {
      legend: {
        labels: isMobile ? { padding: 7, color: "#fff" } : { padding: 7 },
      },
    },
  };

  let EPdata = {
    labels: ["Inventing", "Founding", "Developing"],
    datasets: [
      {
        label: "My Data",
        data: [
          scorePercent(resultSet.EntrepreneurialPassion.Inventing, ResultFeedback.EntrepreneurialPassion.Inventing.scale.max),
          scorePercent(resultSet.EntrepreneurialPassion.Founding, ResultFeedback.EntrepreneurialPassion.Founding.scale.max),
          scorePercent(resultSet.EntrepreneurialPassion.Developing, ResultFeedback.EntrepreneurialPassion.Developing.scale.max),
        ],
        fill: true,
        backgroundColor: [
          isMobile ? "rgba(255, 71, 26, 0.3)" : "rgba(217, 98, 48, 0.2)",
        ],
        borderColor: ["rgb(217, 98, 48)"],
        borderWidth: 1,
        pointBackgroundColor: ["rgba(217, 98, 48,0.5)"],
      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(EntrepreneurialPassionInventing, ResultFeedback.EntrepreneurialPassion.Inventing.scale.max),
          scorePercent(EntrepreneurialPassionFounding, ResultFeedback.EntrepreneurialPassion.Founding.scale.max),
          scorePercent(EntrepreneurialPassionDeveloping, ResultFeedback.EntrepreneurialPassion.Developing.scale.max),
        ],
        backgroundColor: "rgba(74, 73, 72, 0.2)",
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72,0.5)"],
      },
    ],
  };

  let EPOptions = {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 30,
      },
    },
    scale: {
      max: 100,
      min: 0,
    },

    elements: {
      line: {
        tension: 0.3,
      },
    },
    scales: {
      r: {
        pointLabels: isMobile ? { color: "#fff" } : {},
        ticks: {
          backdropColor: isMobile ? "#39AC7E" : "white",

          color: isMobile? "white" : "black"
        },
        grid: {
          circular: true,
          color: isMobile ? "#D3D3D3" : [
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(219,125,21,0.7)",
          ],
        },
      },
    },
    plugins: {
      legend: {
        labels: isMobile
          ? { padding: 0, color: "#fff", font: { size: 10 }, boxWidth: 20 }
          : { padding: 4, boxWidth: 30 },
      },
    },
  };

  let IEOData = {
    labels: ["Risk Taking", "Innovativeness", "Proactivity"],
    datasets: [
      {
        label: "My Data",
        data: [
          (resultSet.IndividualEntrepreneurialOrientation.RiskTaking /
            ResultFeedback.IndividualEntrepreneurialOrientation.RiskTaking.scale
              .max) *
            100,
          (resultSet.IndividualEntrepreneurialOrientation.Innovativeness /
            ResultFeedback.IndividualEntrepreneurialOrientation.Innovativeness
              .scale.max) *
            100,
          (resultSet.IndividualEntrepreneurialOrientation.Proactivity /
            ResultFeedback.IndividualEntrepreneurialOrientation.Proactivity
              .scale.max) *
            100,
        ],
        backgroundColor: [
          isMobile ? "rgba(255, 71, 26, 0.3)" : "rgba(217, 98, 48, 0.2)",
        ],
        borderColor: ["rgb(217, 98, 48)"],
        borderWidth: 1,
        pointBackgroundColor: ["rgb(217, 98, 48,0.5)"],
      },
      {
        label: "Average Entremap User",
        data: [
          (IndividualEntrepreneurialOrientationRiskTaking /
            ResultFeedback.IndividualEntrepreneurialOrientation.RiskTaking.scale
              .max) *
            100,
          (IndividualEntrepreneurialOrientationInnovativeness /
            ResultFeedback.IndividualEntrepreneurialOrientation.Innovativeness
              .scale.max) *
            100,
          (IndividualEntrepreneurialOrientationProactivity /
            ResultFeedback.IndividualEntrepreneurialOrientation.Proactivity
              .scale.max) *
            100,
        ],
        backgroundColor: [
          isMobile ? "rgba(240,196,172, 0.4)" : "rgba(74, 73, 72, 0.2)",
        ],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72,0.5)"],
      },
    ],
  };

  let IEOOptions = {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 30,
      },
    },
    scale: {
      max: 100,
      min: 0,
    },

    elements: {
      line: {
        tension: 0.3,
      },
    },
    scales: {
      r: {
        pointLabels: isMobile ? { color: "#fff" } : {},
        ticks: {
          backdropColor: isMobile ? "#39AC7E" : "white",

          color: isMobile? "white" : "black"
        },
        grid: {
          circular: true,
          color: isMobile ? "#D3D3D3" : [
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(219,125,21,0.7)",
          ],
        },
      },
    },
    plugins: {
      legend: {
        labels: isMobile
          ? { padding: 0, color: "#fff", font: { size: 10 }, boxWidth: 20 }
          : { padding: 4, boxWidth: 30 },
      },
    },
  };

  let ESEData = {
    labels: [
      "Searching",
      "Planning",
      "Marshaling",
      ["Implementing", "(People)"],
      ["Implementing", "(Financial)"],
    ],
    datasets: [
      {
        label: "My Data",
        data: [
          scorePercent(resultSet.EntrepreneurialSelfEfficacy.Searching, ResultFeedback.EntrepreneurialSelfEfficacy.Searching.scale.max),
          scorePercent(resultSet.EntrepreneurialSelfEfficacy.Planning, ResultFeedback.EntrepreneurialSelfEfficacy.Planning.scale.max),
          scorePercent(resultSet.EntrepreneurialSelfEfficacy.Marshaling, ResultFeedback.EntrepreneurialSelfEfficacy.Marshaling.scale.max),
          (resultSet.EntrepreneurialSelfEfficacy.ImplementingPeople /
            ResultFeedback.EntrepreneurialSelfEfficacy.ImplementingPeople.scale
              .max) *
            100,
          (resultSet.EntrepreneurialSelfEfficacy.ImplementingFinancial /
            ResultFeedback.EntrepreneurialSelfEfficacy.ImplementingFinancial
              .scale.max) *
            100,
        ],
        backgroundColor: [
          "rgb(227,156,68)",
          "rgb(220,146,57)",
          "rgb(220,140,42)",
          "rgb(220,132,36)",
          "rgb(219,125,21)",
        ],
        borderColor: ["rgb(217, 98, 48)"],
        borderWidth: 1,
      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(EntrepreneurialSelfEfficacySearching, ResultFeedback.EntrepreneurialSelfEfficacy.Searching.scale.max),
          scorePercent(EntrepreneurialSelfEfficacyPlanning, ResultFeedback.EntrepreneurialSelfEfficacy.Planning.scale.max),
          scorePercent(EntrepreneurialSelfEfficacyMarshaling, ResultFeedback.EntrepreneurialSelfEfficacy.Marshaling.scale.max),
          (EntrepreneurialSelfEfficacyImplementingPeople /
            ResultFeedback.EntrepreneurialSelfEfficacy.ImplementingPeople.scale
              .max) *
            100,
          (EntrepreneurialSelfEfficacyImplementingFinancial /
            ResultFeedback.EntrepreneurialSelfEfficacy.ImplementingFinancial
              .scale.max) *
            100,
        ],
        backgroundColor: ["rgba(74, 73, 72, 0.7)"],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
      },
    ],
  };

  let ESEOptions = {
    scales: {
      yAxes: {
        beginAtZero: true,
        max: 100,
        ticks: isMobile
          ? {
              color: "#ffffff",
            }
          : {},
          grid: {
            color: isMobile ? "#D3D3D3" : "black"
          },
      },
      xAxes: {
        display: true,
        ticks: isMobile
          ? {
              color: "#ffffff",
              font: {
                size: 9,
              },
            }
          : {
              font: {
                size: 9,
              },
            },
            grid: {
              color: isMobile ? "#D3D3D3" : "black"
            },
      },
    },
    plugins: {
      legend: {
        labels: isMobile ? { padding: 7, color: "#fff" } : { padding: 7 },
      },
    },
  };

  let FOFData = {
    labels: [
      ["Ability", "to Fund", "the Venture"],
      ["Potential", "of the", "Idea"],
      ["Threat to", "Social", "Esteem"],
      ["Opportunity", "Costs"],
      ["Personal", "Ability"],
      ["Financial", "Security"],
      ["Venture's", "Capacity"],
    ],
    datasets: [
      {
        label: "My Data",
        data: [
          scorePercent(resultSet.FearOfFailure.AbilityToFundTheVenture, ResultFeedback.FearOfFailure.AbilityToFundTheVenture.scale.max),
          scorePercent(resultSet.FearOfFailure.PotentialOfTheIdea, ResultFeedback.FearOfFailure.PotentialOfTheIdea.scale.max),
          scorePercent(resultSet.FearOfFailure.ThreatToSocialEsteem, ResultFeedback.FearOfFailure.ThreatToSocialEsteem.scale.max),
          scorePercent(resultSet.FearOfFailure.OpportunityCosts, ResultFeedback.FearOfFailure.OpportunityCosts.scale.max),

          scorePercent(resultSet.FearOfFailure.PersonalAbility, ResultFeedback.FearOfFailure.PersonalAbility.scale.max),
          scorePercent(resultSet.FearOfFailure.FinancialSecurity, ResultFeedback.FearOfFailure.FinancialSecurity.scale.max),
          scorePercent(resultSet.FearOfFailure.VenturesCapacity, ResultFeedback.FearOfFailure.VenturesCapacity.scale.max),
        ],
        backgroundColor: [
          "rgb(228,166,91)",
          "rgb(227,156,77)",
          "rgb(227,156,68)",
          "rgb(220,146,57)",
          "rgb(220,140,42)",
          "rgb(220,132,36)",
          "rgb(219,125,21)",
        ],
        borderColor: isMobile ? "#fff" : ["rgb(217, 98, 48)"],
        borderWidth: 1,
      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(FearOfFailureAbilityToFundTheVenture, ResultFeedback.FearOfFailure.AbilityToFundTheVenture.scale.max),
          scorePercent(FearOfFailurePotentialOfTheIdea, ResultFeedback.FearOfFailure.PotentialOfTheIdea.scale.max),
          scorePercent(FearOfFailureThreatToSocialEsteem, ResultFeedback.FearOfFailure.ThreatToSocialEsteem.scale.max),
          scorePercent(FearOfFailureOpportunityCosts, ResultFeedback.FearOfFailure.OpportunityCosts.scale.max),

          scorePercent(FearOfFailurePersonalAbility, ResultFeedback.FearOfFailure.PersonalAbility.scale.max),
          scorePercent(FearOfFailureFinancialSecurity, ResultFeedback.FearOfFailure.FinancialSecurity.scale.max),
          scorePercent(FearOfFailureVenturesCapacity, ResultFeedback.FearOfFailure.VenturesCapacity.scale.max),
        ],
        backgroundColor: ["rgba(74, 73, 72, 0.7)"],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
      },
    ],
  };

  let FOFOptions = {
    scales: {
      yAxes: {
        beginAtZero: true,
        max: 100,
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        },
        ticks: isMobile
          ? {
              color: "#ffffff",
            }
          : {},
      },
      xAxes: {
        display: true,
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        },
        ticks: isMobile
          ? {
              color: "#ffffff",
              font: {
                size: 8,
              },
            }
          : {
              font: {
                size: 8,
              },
            },
      },
    },
    plugins: {
      legend: {
        labels: isMobile ? { padding: 7, color: "#fff" } : { padding: 7 },
      },
    },
  };

  let TBFdata = {
    labels: [
      "Extraversion",
      "Agreeableness",
      "Conscientiousness",
      "Neuroticism",
      "Openness",
    ],
    datasets: [
      {
        label: "My Data",
        data: [
          scorePercent(resultSet.TheBigFive.Extraversion, ResultFeedback.TheBigFive.Extraversion.scale.max),
          scorePercent(resultSet.TheBigFive.Agreeableness, ResultFeedback.TheBigFive.Agreeableness.scale.max),
          scorePercent(resultSet.TheBigFive.Conscientiousness, ResultFeedback.TheBigFive.Conscientiousness.scale.max),
          scorePercent(resultSet.TheBigFive.Neuroticism, ResultFeedback.TheBigFive.Neuroticism.scale.max),
          scorePercent(resultSet.TheBigFive.Openness, ResultFeedback.TheBigFive.Openness.scale.max),
        ],
        backgroundColor: [
          isMobile ? "rgba(255, 71, 26, 0.3)" : "rgb(217, 98, 48 ,0.2)",
        ],
        borderColor: ["rgb(217, 98, 48)"],
        borderWidth: 1,
        pointBackgroundColor: ["rgb(217, 98, 48,0.5)"],
      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(TheBigFiveExtraversion, ResultFeedback.TheBigFive.Extraversion.scale.max),
          scorePercent(TheBigFiveAgreeableness, ResultFeedback.TheBigFive.Agreeableness.scale.max),
          scorePercent(TheBigFiveConscientiousness, ResultFeedback.TheBigFive.Conscientiousness.scale.max),
          scorePercent(TheBigFiveNeuroticism, ResultFeedback.TheBigFive.Neuroticism.scale.max),
          scorePercent(TheBigFiveOpenness, ResultFeedback.TheBigFive.Openness.scale.max),
        ],
        backgroundColor: [
          isMobile ? "rgba(240,196,172, 0.4)" : "rgba(74, 73, 72, 0.2)",
        ],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72,0.5)"],
      },
    ],
  };

  let TBFOptions = {
    scale: {
      max: 100,
      min: 0,
    },
    elements: {
      line: {
        tension: 0.2,
      },
    },
    scales: {
      r: {
        pointLabels: isMobile ? { color: "#fff" } : {},
        ticks: {
          backdropColor: isMobile ? "#39AC7E" : "white",

          color: isMobile ? "white" : "black",
        },
        grid: {
          circular: true,
          color: isMobile ? "#D3D3D3" : [
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(219,125,21,0.7)",
          ],
        },
      },
    },
    plugins: {
      legend: {
        labels: isMobile ? { padding: 7, color: "#fff" } : { padding: 7 },
      },
    },
  };

  let CUdata = {
    labels: [
      "Joyous Exploration",
      "Deprivation Sensitivity",
      "Stress Tolerance",
      "Thrill Seeking",
      "Overt Social",
      "Covert Social",
    ],
    datasets: [
      {
        label: "My Data",
        data: [
          scorePercent(resultSet.Curiosity.JoyousExploration, ResultFeedback.Curiosity.JoyousExploration.scale.max),
          scorePercent(resultSet.Curiosity.DeprivationSensitivity, ResultFeedback.Curiosity.DeprivationSensitivity.scale.max),
          scorePercent(resultSet.Curiosity.StressTolerance, ResultFeedback.Curiosity.StressTolerance.scale.max),
          scorePercent(resultSet.Curiosity.ThrillSeeking, ResultFeedback.Curiosity.ThrillSeeking.scale.max),
          scorePercent(resultSet.Curiosity.OvertSocial, ResultFeedback.Curiosity.OvertSocial.scale.max),
          scorePercent(resultSet.Curiosity.CovertSocial, ResultFeedback.Curiosity.CovertSocial.scale.max),
        ],
        backgroundColor: [
          isMobile ? "rgba(255, 71, 26, 0.3)" : "rgb(217, 98, 48 ,0.2)",
        ],
        borderColor: ["rgb(217, 98, 48)"],
        borderWidth: 1,
        pointBackgroundColor: ["rgb(217, 98, 48,0.5)"],
      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(CuriosityJoyousExploration, ResultFeedback.Curiosity.JoyousExploration.scale.max),
          scorePercent(CuriosityDeprivationSensitivity, ResultFeedback.Curiosity.DeprivationSensitivity.scale.max),
          scorePercent(CuriosityStressTolerance, ResultFeedback.Curiosity.StressTolerance.scale.max),
          scorePercent(CuriosityThrillSeeking, ResultFeedback.Curiosity.ThrillSeeking.scale.max),
          scorePercent(CuriosityOvertSocial, ResultFeedback.Curiosity.OvertSocial.scale.max),
          scorePercent(CuriosityCovertSocial, ResultFeedback.Curiosity.CovertSocial.scale.max),
        ],
        backgroundColor: [
          isMobile ? "rgba(240,196,172, 0.4)" : "rgba(74, 73, 72, 0.2)",
        ],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        pointBackgroundColor: [isMobile ? "#fff" : "rgb(74, 73, 72,0.5)"],
      },
    ],
  };

  let CUOptions = {
    scale: {
      max: 100,
      min: 0,
    },
    elements: {
      line: {
        tension: 0.2,
      },
    },
    scales: {
      r: {
        pointLabels: isMobile ? { color: "#fff" } : {},
        ticks: {
          backdropColor: isMobile ? "#39AC7E" : "white",

          color: isMobile ? "white" : "black",
        },
        grid: {
          circular: true,
          color: isMobile ? "#D3D3D3" :
            ["rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(74, 73, 72,0.2)",
            "rgb(219,125,21,0.7)"
          ],
        },
      },
    },
    plugins: {
      legend: {
        labels: isMobile ? { padding: 3, color: "#fff" } : { padding: 3},
      },
    },
  };

  let growthData = {
    labels: [
      "Growth Orientation",
      "Growth Mindset",
      "Cognitive Flexibility",
      "Grit",
      "Resilience",
    ],

    datasets: [
      {
        label: "My Data",

        data: [
          scorePercent(resultSet.GrowthOrientation.Total, ResultFeedback.GrowthOrientation.Total.scale.max),

          scorePercent(resultSet.GrowthMindset.Total, ResultFeedback.GrowthMindset.Total.scale.max),

          scorePercent(resultSet.CognitiveFlexibility.Total, ResultFeedback.CognitiveFlexibility.Total.scale.max),

          scorePercent(resultSet.Grit.Total, ResultFeedback.Grit.Total.scale.max),

          scorePercent(resultSet.Resilience.Total, ResultFeedback.Resilience.Total.scale.max),
        ],

        backgroundColor: [isMobile ? "rgb(220,132,36)" : "rgb(220,132,36)"],

        borderColor: [isMobile ? "#fff" :"rgb(217, 98, 48)"],

        borderWidth: 1,

      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(GrowthOrientationValue, ResultFeedback.GrowthOrientation.Total.scale.max),
          scorePercent(GrowthMindsetValue, ResultFeedback.GrowthMindset.Total.scale.max),
          scorePercent(CognitiveFlexibilityValue, ResultFeedback.CognitiveFlexibility.Total.scale.max),
          scorePercent(GritValue, ResultFeedback.Grit.Total.scale.max),
          scorePercent(ResilienceValue, ResultFeedback.Resilience.Total.scale.max),
        ],
        backgroundColor: [
          isMobile ? "rgba(74, 73, 72, 0.7)" : "rgba(74, 73, 72, 0.7)",
        ],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
      },
    ],
  };

  let growthOptions = {
    indexAxis: "y",
    plugins: {
      legend: {
        labels: isMobile
          ? { padding: 3, color: "#fff"}
          : { padding: 4},
      },
    },
    scales: {
      x: {
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        },
        ticks: {
          color: isMobile ? "white" : "black"
        }
      },
      y: {
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        
        },
        ticks: {
          color: isMobile ? "white" : "black"
        }
      }
    },
    scale: {
      max: 100,

      min: 0,
      

      elements: {
        bar: {
          borderWidth: 2,
        },
      },
    },
    
      responsive: true,
    
  };

  let growth2Data = {
    labels: [
      "Rule-Breaking",
      "Empathy",
      "Need to Achieve",
      "Imposter Syndrome",
      "Tolerance for Ambiguity",
    ],

    datasets: [
      {
        label: "My Data",

        data: [
          (resultSet.RuleBreaking.Total / // change to rulebreaking.Total
            ResultFeedback.RuleBreaking.Total.scale.max) *
            100,

          scorePercent(resultSet.Empathy.Total, ResultFeedback.Empathy.Total.scale.max),

          scorePercent(resultSet.NeedToAchieve.Total, ResultFeedback.NeedToAchieve.Total.scale.max),

          scorePercent(resultSet.ImposterSyndrome.Total, ResultFeedback.ImposterSyndrome.Total.scale.max),

          scorePercent(resultSet.ToleranceForAmbiguity.Total, ResultFeedback.ToleranceForAmbiguity.Total.scale.max),
        ],

        backgroundColor: [isMobile ? "rgb(220,132,36)" : "rgb(220,132,36)"],

        borderColor: ["rgb(217, 98, 48)"],

        borderWidth: 1,

      },
      {
        label: "Average Entremap User",
        data: [
          scorePercent(RuleBreakingValue, ResultFeedback.RuleBreaking.Total.scale.max),
          scorePercent(EmpathyValue, ResultFeedback.Empathy.Total.scale.max),
          scorePercent(NeedToAchieveValue, ResultFeedback.NeedToAchieve.Total.scale.max),
          scorePercent(ImposterSyndromeValue, ResultFeedback.ImposterSyndrome.Total.scale.max),
          scorePercent(ToleranceForAmbiguityValue, ResultFeedback.ToleranceForAmbiguity.Total.scale.max),
        ],
        backgroundColor: [
          isMobile ? "rgba(74, 73, 72, 0.7)" : "rgba(74, 73, 72, 0.7)",
        ],
        borderColor: [isMobile ? "#fff" : "rgb(74, 73, 72)"],
        borderWidth: 1,
        //pointBackgroundColor: [isMobile ? '#fff' : 'rgb(74, 73, 72,0.5)'],
      },
    ],
  };

  let growth2Options = {
    indexAxis: "y",
    plugins: {
      legend: {
        labels: isMobile
          ? { padding: 3, color: "#fff"}
          : { padding: 4},
      },
    },
    scales: {
      x: {
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        },
        ticks: {
          color: isMobile ? "white" : "black"
        }
      },
      y: {
        grid: {
          color: isMobile ? "#D3D3D3" : "black"
        
        },
        ticks: {
          color: isMobile ? "white" : "black"
        }
      }
    },
    scale: {
      max: 100,

      min: 0,
      

      elements: {
        bar: {
          borderWidth: 2,
        },
      },
    },
    
      responsive: true,
    
  };

      // Create and Export PDF Document
  // Export Report Review:
  // Captures the complete extended report inside REF and splits it
  // into readable A4 PDF pages without repeatedly repositioning
  // the same full-size canvas.

  const getDocument = () => {
    const input = document.getElementById("REF");

    // Prevent export from continuing if the report container
    // cannot be found.
    if (!input) {
      console.error(
        "Export Report Review: report content with ID 'REF' was not found."
      );
      return;
    }

    html2canvas(input, {
      logging: true,
      letterRendering: 1,
      useCORS: true,
      scale: 2,
      backgroundColor: "#ffffff",
    })
      .then((canvas) => {
        // PDF configuration
        const pdfDOC = new jsPDF("p", "mm", "a4");

        const pageWidth = 210;
        const pageHeight = 297;

        // Existing EntreMap page layout
        const contentLeft = 15;
        const contentTop = 15;
        const contentWidth = 180;

        // Footer starts at 282 mm.
        // Leave a small gap above it so report content
        // never overlaps the footer.
        const contentBottom = 277;
        const contentHeight = contentBottom - contentTop;

        // Determine how tall the complete captured report
        // would be when scaled to the PDF content width.
        const fullImageHeight =
          (canvas.height * contentWidth) / canvas.width;

        // Convert the available PDF page height back into
        // source-canvas pixels.
        const defaultSliceHeightPx = Math.floor(
          (contentHeight / fullImageHeight) * canvas.height
        );

        // Identify major report headings.
        // These are used as preferred page-break locations
        // so a heading is less likely to appear at the very
        // bottom of one page with its content on the next page.
        const reportRect = input.getBoundingClientRect();

        const headingBreakPoints = Array.from(
          input.querySelectorAll("h5")
        )
          .map((heading) => {
            const headingRect = heading.getBoundingClientRect();

            return Math.round(
              (headingRect.top - reportRect.top) *
                (canvas.height / input.scrollHeight)
            );
          })
          .filter(
            (point) =>
              point > 0 &&
              point < canvas.height
          );

        let sourceY = 0;
        let pageIndex = 0;

        while (sourceY < canvas.height) {
          // Normal page size.
          let currentSliceHeight = Math.min(
            defaultSliceHeightPx,
            canvas.height - sourceY
          );

          const maximumPageEnd =
            sourceY + currentSliceHeight;

          // Look for a major heading within the latter part
          // of the current page. If one exists, finish the
          // current page immediately before that heading.
          const safeBreakPoints =
            headingBreakPoints.filter(
              (point) =>
                point >
                  sourceY +
                    defaultSliceHeightPx * 0.55 &&
                point < maximumPageEnd
            );

          if (safeBreakPoints.length > 0) {
            const bestBreakPoint =
              safeBreakPoints[
                safeBreakPoints.length - 1
              ];

            currentSliceHeight =
              bestBreakPoint - sourceY;
          }

          // Safety guard against an invalid or zero-height slice.
          if (currentSliceHeight <= 0) {
            currentSliceHeight = Math.min(
              defaultSliceHeightPx,
              canvas.height - sourceY
            );
          }

          // Create a temporary canvas containing only
          // the section required for this PDF page.
          const pageCanvas =
            window.document.createElement("canvas");

          pageCanvas.width = canvas.width;
          pageCanvas.height = currentSliceHeight;

          const pageContext =
            pageCanvas.getContext("2d");

          if (!pageContext) {
            throw new Error(
              "Export Report Review: unable to create PDF page canvas."
            );
          }

          pageContext.drawImage(
            canvas,
            0,
            sourceY,
            canvas.width,
            currentSliceHeight,
            0,
            0,
            canvas.width,
            currentSliceHeight
          );

          const pageImgData =
            pageCanvas.toDataURL("image/png");

          const sliceHeightMm =
            (currentSliceHeight * contentWidth) /
            canvas.width;

          // Add another A4 page after the first page.
          if (pageIndex > 0) {
            pdfDOC.addPage();
          }

          // --------------------------------------------------
          // EntreMap PDF page styling
          // --------------------------------------------------

          // Green page background
          pdfDOC.setFillColor("#39AC7E");
          pdfDOC.rect(
            0,
            0,
            pageWidth,
            pageHeight,
            "F"
          );

          // White report area
          pdfDOC.setFillColor("white");
          pdfDOC.roundedRect(
            5,
            5,
            200,
            280,
            5,
            5,
            "F"
          );

          // Add only the current report slice.
          pdfDOC.addImage(
            pageImgData,
            "PNG",
            contentLeft,
            contentTop,
            contentWidth,
            sliceHeightMm
          );

          // --------------------------------------------------
          // Footer
          // --------------------------------------------------

          pdfDOC.setFillColor("#d96230");
          pdfDOC.rect(
            0,
            282,
            pageWidth,
            15,
            "F"
          );

          pdfDOC.setTextColor("white");
          pdfDOC.setFontSize(11);

          pdfDOC.text(
            "© Copyright 2023 - Entremap - All rights reserved.",
            5,
            291
          );

          pdfDOC.text(
            "Contact: entremapco@gmail.com",
            147,
            291
          );

          // Move to the next uncaptured section.
          sourceY += currentSliceHeight;
          pageIndex += 1;
        }

        // Save the completed extended report.
        pdfDOC.save(
          "YourMindsetReportExtended.PDF"
        );
      })
      .catch((error) => {
        console.error(
          "Export Report Review: PDF export failed.",
          error
        );
      });
  };
  return (
    <div className="emap-report-page"
      style={{
        backgroundColor: '#f5f8f5',
        pageBreakAfter: 'always',
      }}
    >
      <NavBar isLoggedIn={true} />
      <div
        style={{
          margin: 'auto',
          width: '100%',
          paddingTop: '30px',
          paddingBottom: '50px',
        }}
      >
        <Box
          boxShadow={1}
          color="text.primary"
          id={'Result'}
          style={{
            margin: 'auto',
            width: isMobile ? '100vw' : '794px',
            backgroundColor: isMobile ? 'transparent' : 'white',
            padding: isMobile ? '0 12px' : '2vw',
            marginBottom: '10px',
            boxSizing: isMobile ? 'border-box' : 'unset',
            boxShadow: isMobile ? 'none' : undefined,
          }}
        >
          <ReactToPrint
            trigger={() => (
              <Button
                variant="contained"
                size={isMobile ? 'small' : 'large'}
                color="primary"
                style={{ marginRight: isMobile ? '4px' : '50px' }}
              >
                Print
              </Button>
            )}
            pageStyle="@media all {
                            .page-break {
                              display: none;
                            }
                          }
                          @media print {
                            html, body {
                              height: initial !important;
                              overflow: initial !important;
                              -webkit-print-color-adjust: exact;
                            }
                          }
                          @media print {
                            .page-break {
                              margin-top: 1rem;
                              display: block;
                              page-break-before: auto;
                            }
                          }
                          @page {
                            size: auto;
                            margin: 10mm;
                          }"
            content={() => componentRef.current}
          />
          <Button
            variant="contained"
            size={isMobile ? 'small' : 'large'}
            color="primary"
            component={Link}
            to={{ pathname: '/results', state: props.location.state }}
          >
            Overview
          </Button>
          {/* GET PDF FUNCTION */}
          <Button
            variant="contained"
            size={isMobile ? 'small' : 'large'}
            color="primary"
            style={{ marginRight: isMobile ? '4px' : '50px' }}
            onClick={()=>getDocument()}
          >
            Export PDF
          </Button>
        </Box>
        <Box
          boxShadow={1}
          color="text.primary"
          id={'Result'}
          style={{
            margin: 'auto',
            width: isMobile ? '100vw' : '794px',
            minHeight: '1123px',
            backgroundColor: isMobile ? 'transparent' : 'white',
            padding: isMobile ? '0 12px' : '2vw',
            boxSizing: isMobile ? 'border-box' : 'unset',
            color: '#122c33',
          }}
        >
          <div
            id='REF'
            ref={componentRef}
            style={{
              width: isMobile ? '100%' : '790px',
              minHeight: '1120px',
            }}
          >
            <Typography
              variant="h5"
              align="center"
              color= {isMobile ? "white" : "primary"}
              padding="30px"
            >
              Entremap Mindset Report
            </Typography>
            <div style={{ height: 6, width: "100%", opacity: 0 }} />
            <div style={{ height: 6, width: "100%", opacity: 0 }} />
            <div style={{ height: 6, width: "100%", opacity: 0 }} />
            <div
              style={{
                height: 2,
                width: "100%",
                backgroundColor: "#39AC7E",
                opacity: 0.7,
              }}
            />
            <Divider></Divider>
            <div style={{ height: 12, width: "100%" }} />
            <div style={{ height: 15, width: "100%", opacity: 0 }} />
            <Typography
              variant="body1"
              align="left"
              padding="30px"
              color= {isMobile ? "white" : "primary"}
            >
              The Entremap Mindset Report allows you to have a deeper look into
your entrepreneurial mindset, backed by extensive research.
You can compare your scores against benchmark averages calculated from completed survey responses stored in the system. Knowing your
              strengths and weaknesses can help you grow as an entrepreneur and
              make better decisions. You can also retake this survey to track
              and compare your growth as an entrepreneur over time.
            </Typography>
            <div>
              <Typography
                variant="h5"
                align="center"
                color= {isMobile ? "white" : "primary"}
                style={{ paddingTop: "30px", paddingBottom: "15px" }}
              >
                Motivation at Work
              </Typography>
              <Grid
                container
                p={28}
                spacing={2}
                direction="row"
                justify="flex-end"
                alignItems="center"
              >
                <Bar options={MaWoptions} data={withAvailableBenchmark(MaWdata)} height ={250} width={560} style={{ margin: "auto" }}/>
              </Grid>
              <Grid container spacing={5}>
                <Grid item xs="12" sm="12" style={{ paddingTop: "30px" }}>
                  <Typography gutterBottom>
                    {getResponse(
                      "MotivationAtWork.Intrinsic",
                      resultSet.MotivationAtWork.Intrinsic
                    )}
                  </Typography>
                  <Typography gutterBottom>
                    {getResponse(
                      "MotivationAtWork.Identified",
                      resultSet.MotivationAtWork.Identified
                    )}
                  </Typography>
                  <Typography gutterBottom>
                    {getResponse(
                      "MotivationAtWork.Introjected",
                      resultSet.MotivationAtWork.Introjected
                    )}
                  </Typography>

                  <Typography gutterBottom>
                    {getResponse(
                      "MotivationAtWork.ExternalMotivation",
                      resultSet.MotivationAtWork.ExternalMotivation
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </div>
            <Typography
              variant="h5"
              align="center"
              color= {isMobile ? "white" : "primary"}
              style={{ paddingTop: "30px", paddingBottom: "15px" }}
            >
              Entrepreneurial Passion
            </Typography>
            <Grid
              container
              p={28}
              spacing={2}
              direction="row"
              justify="flex-end"
              alignItems="center"
            >
              <Radar options={EPOptions} data={withAvailableBenchmark(EPdata)} height={400} style={{ margin: "auto" }}/>
            </Grid>
            <Grid container spacing={5}>
            <Grid item xs="12" sm="12" style={{ paddingTop: "30px" }}>
              <Typography gutterBottom style={{ paddingTop: "30px" }}>
                {getResponse(
                  "EntrepreneurialPassion.Total",
                  resultSet.EntrepreneurialPassion.Total
                )}
              </Typography>
            </Grid>
            </Grid>
            <div>
              <Typography
                variant="h5"
                align="center"
                color= {isMobile ? "white" : "primary"}
                style={{ paddingTop: "30px", paddingBottom: "15px" }}
              >
                Passion Scale
              </Typography>

              <Grid container spacing={5}>
                <Grid item xs="12" sm="6">
                  <Typography
                    variant="h6"
                    style={{ textAlign: "center" }}
                    gutterBottom
                  >
                    Harmonious Passion
                  </Typography>
                  <Progress
                    variant="determinate"
                    value={
                      (resultSet.PassionScale.HarmoniousPassion /
                        ResultFeedback.PassionScale.HarmoniousPassion.scale
                          .max) *
                      100
                    }
                    style={{
                      height: "10px",
                      maxWidth: "300px",
                      margin: "auto",
                    }}
                  />
                </Grid>
                
                <Grid item xs="12" sm="6">
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    Obsessive Passion
                  </Typography>
                  <Progress
                    variant="determinate"
                    value={
                      (resultSet.PassionScale.ObsessivePassion /
                        ResultFeedback.PassionScale.ObsessivePassion.scale
                          .max) *
                      100
                    }
                    style={{
                      height: "10px",
                      maxWidth: "300px",
                      margin: "auto",
                    }}
                  />
                </Grid>
              </Grid>
            </div>
            <Grid container spacing={5} style={{ paddingTop: "30px" }}>
                <Grid item xs="12" sm="12">
                  <Typography gutterBottom> 
                  {getResponse(
                      "PassionScale.HarmoniousPassion.Total",
                      resultSet.PassionScale.HarmoniousPassion.Total
                    )}
                  {getResponse(
                      "PassionScale.ObsessivePassion.Total",
                      resultSet.PassionScale.ObsessivePassion.Total
                    )}
                  </Typography>
                </Grid>
              </Grid>
            <div>
              {" "}
              <Typography
                variant="h5"
                align="center"
                color= {isMobile ? "white" : "primary"}
                style={{ paddingTop: "30px", paddingBottom: "15px" }}
              >
                Individual Entrepreneurial Orientation
              </Typography>
              <div style={{ maxWidth: "1000px", maxHeight: "1000px" }}>
                <Radar
                  data={withAvailableBenchmark(IEOData)}
                  height={400}
                  options={IEOOptions}
                  style={{ margin: "auto" }}
                />
              </div>
              <Grid container spacing={5} style={{ paddingTop: "30px" }}>
                <Grid item xs="12" sm="12">
                  <Typography gutterBottom>
                    {getResponse(
                      "IndividualEntrepreneurialOrientation.RiskTaking",
                      resultSet.IndividualEntrepreneurialOrientation.RiskTaking
                    )}
                  </Typography>
                  <Typography gutterBottom>
                    {getResponse(
                      "IndividualEntrepreneurialOrientation.Innovativeness",
                      resultSet.IndividualEntrepreneurialOrientation
                        .Innovativeness
                    )}
                  </Typography>
                  <Typography gutterBottom>
                    {getResponse(
                      "IndividualEntrepreneurialOrientation.Proactivity",
                      resultSet.IndividualEntrepreneurialOrientation.Proactivity
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </div>
            <div>
              <Typography
                variant="h5"
                align="center"
                color= {isMobile ? "white" : "primary"}
                style={{ paddingTop: "30px", paddingBottom: "15px" }}
              >
                Entrepreneurial Self Efficacy
              </Typography>
              <Bar options={ESEOptions} data={withAvailableBenchmark(ESEData)} height ={isMobile ? 250 : 300} width={isMobile ? 350 : 700} style={{ margin: "auto" }}/>
              <Typography
                gutterBottom
                style={{ paddingTop: "30px", paddingBottom: "30px" }}
              >
                {getResponse(
                  "EntrepreneurialSelfEfficacy.Total",
                  resultSet.EntrepreneurialSelfEfficacy.Total
                )}
              </Typography>
            </div>

            <div>
              <Typography
                variant="h5"
                align="center"
                color= {isMobile ? "white" : "primary"}
                style={{ paddingTop: "30px", paddingBottom: "15px" }}
              >
                Well-Rounded Cognitive Function
              </Typography>
              <Bar data={withAvailableBenchmark(growthData)} options={growthOptions} height ={isMobile ? 250: 300} width={isMobile ? 350 : 700} style={{ margin: "auto" }}/>
            </div>

            <div>
              <Typography
                variant="h5"
                align="center"
                color= {isMobile ? "white" : "primary"}
                style={{ paddingTop: "30px", paddingBottom: "15px" }}
              >
                Adaptive Success
              </Typography>
              <Bar data={withAvailableBenchmark(growth2Data)} options={growth2Options} height ={isMobile? 250:300} width={isMobile?350:700} style={{ margin: "auto" }}/>
            </div>
            <div></div>

            <Grid container spacing={3}>
              <Grid item xs="12" sm="4">
                <SectionProgress
                  name="Cognitive Flexibility"
                  value={
                    scorePercent(resultSet.CognitiveFlexibility.Total, ResultFeedback.CognitiveFlexibility.Total.scale.max)
                  }
                />
              </Grid>
              <Grid item xs="12" sm="8">
                <Typography gutterBottom style={{ paddingTop: "30px" }}>
                  {getResponse(
                    "CognitiveFlexibility.Total",
                    resultSet.CognitiveFlexibility.Total
                  )}
                </Typography>
              </Grid>
              <Grid item xs="12" sm="4">
                <SectionProgress
                  name="Empathy"
                  value={
                    scorePercent(resultSet.Empathy.Total, ResultFeedback.Empathy.Total.scale.max)
                  }
                />
              </Grid>
              <Grid item xs="12" sm="8">
                <Typography gutterBottom style={{ paddingTop: "30px" }}>
                  {getResponse("Empathy.Total", resultSet.Empathy.Total)}
                </Typography>
              </Grid>
              <Grid item xs="12" sm="4">
                <SectionProgress
                  name="Need to Achieve"
                  value={
                    scorePercent(resultSet.NeedToAchieve.Total, ResultFeedback.NeedToAchieve.Total.scale.max)
                  }
                />
              </Grid>
              <Grid item xs="12" sm="8">
                <Typography gutterBottom style={{ paddingTop: "30px" }}>
                  {getResponse(
                    "NeedToAchieve.Total",
                    resultSet.NeedToAchieve.Total
                  )}
                </Typography>
              </Grid>
              <Grid item xs="12" sm="4">
                <SectionProgress
                  name="Grit"
                  value={
                    scorePercent(resultSet.Grit.Total, ResultFeedback.Grit.Total.scale.max)
                  }
                />
              </Grid>
              <Grid item xs="12" sm="8">
                <Typography style={{ paddingTop: "30px" }}>
                  {getResponse("Grit.Total", resultSet.Grit.Total)}
                </Typography>
              </Grid>
              <Grid item xs="12" sm="4">
                <SectionProgress
                  name="Growth Orientation"
                  value={
                    scorePercent(resultSet.GrowthOrientation.Total, ResultFeedback.GrowthOrientation.Total.scale.max)
                  }
                />
              </Grid>
              <Grid item xs="12" sm="8">
                <Typography style={{ paddingTop: "30px" }}>
                  {getResponse(
                    "GrowthOrientation.Total",
                    resultSet.GrowthOrientation.Total
                  )}
                </Typography>
              </Grid>
              <Grid item xs="12" sm="4">
                <SectionProgress
                  name="Tolerance for Ambiguity"
                  value={
                    scorePercent(resultSet.ToleranceForAmbiguity.Total, ResultFeedback.ToleranceForAmbiguity.Total.scale.max)
                  }
                />
              </Grid>
              <Grid item xs="12" sm="8">
                <Typography style={{ paddingTop: "30px" }}>
                  {getResponse(
                    "ToleranceForAmbiguity.Total",
                    resultSet.ToleranceForAmbiguity.Total
                  )}
                </Typography>
              </Grid>
              <Grid item xs="12" sm="4">
                <SectionProgress
                  name="Resilience"
                  value={
                    scorePercent(resultSet.Resilience.Total, ResultFeedback.Resilience.Total.scale.max)
                  }
                />
              </Grid>
              <Grid item xs="12" sm="8">
                <Typography style={{ paddingTop: "30px" }}>
                  {getResponse("Resilience.Total", resultSet.Resilience.Total)}
                </Typography>
              </Grid>
              <Grid item xs="12" sm="4">
                <SectionProgress
                  name="Growth Mindset"
                  value={
                    scorePercent(resultSet.GrowthMindset.Total, ResultFeedback.GrowthMindset.Total.scale.max)
                  }
                />
              </Grid>
              <Grid item xs="12" sm="8">
                <Typography style={{ paddingTop: "30px" }}>
                  {getResponse(
                    "GrowthMindset.Total",
                    resultSet.GrowthMindset.Total
                  )}
                </Typography>
              </Grid>
              <Grid item xs="12" sm="4">
                <SectionProgress
                  name="Rule-Breaking"
                  value={
                    scorePercent(resultSet.RuleBreaking.Total, ResultFeedback.RuleBreaking.Total.scale.max)
                  }
                />
              </Grid>
              <Grid item xs="12" sm="8">
                <Typography style={{ paddingTop: "30px" }}>
                  {getResponse(
                    "RuleBreaking.Total",
                    resultSet.RuleBreaking.Total
                  )}
                </Typography>
              </Grid>
              <Grid item xs="12" sm="4">
                <SectionProgress
                  name="Imposter Syndrome"
                  value={
                    scorePercent(resultSet.ImposterSyndrome.Total, ResultFeedback.ImposterSyndrome.Total.scale.max)
                  }
                />
              </Grid>
              <Grid item xs="12" sm="8">
                <Typography style={{ paddingTop: "30px" }}>
                  {getResponse(
                    "ImposterSyndrome.Total",
                    resultSet.ImposterSyndrome.Total
                  )}
                </Typography>
              </Grid>
              
            </Grid>

            <div>
              <Typography
                variant="h5"
                align="center"
                color= {isMobile ? "white" : "primary"}
                style={{ paddingTop: "30px", paddingBottom: "15px" }}
              >
                Fear of Failure
              </Typography>
              <Bar options={FOFOptions} data={withAvailableBenchmark(FOFData)} />
            </div>
            <Grid container spacing={5} style={{ paddingTop: "30px" }}>
                <Grid item xs="12" sm="12">
                  <Typography gutterBottom>
                    {getResponse( 
                      "FearOfFailure.Total",
                      resultSet.FearOfFailure.Total
                    )}
                   
                  </Typography>
                </Grid>
              </Grid>

              <Typography
                variant="h5"
                align="center"
                color= {isMobile ? "white" : "primary"}
                style={{ paddingTop: "30px", paddingBottom: "15px" }}
              >
                Curiosity
              </Typography>
              <div style={{ maxWidth: "1000px", maxHeight: "1000px" }}>
                <Radar
                  data={withAvailableBenchmark(CUdata)}
                  options={CUOptions}
                />
              </div>
              <Grid container spacing={5} style={{ paddingTop: "30px" }}>
                <Grid item xs="12" sm="12">
                  <Typography gutterBottom>
                    {getResponse(
                      "Curiosity.Total",
                      resultSet.Curiosity.Total
                    )}
                  </Typography>
                  </Grid>
                  </Grid>           
            <div id="REF2">
              <Typography
                variant="h5"
                align="center"
                color= {isMobile ? "white" : "primary"}
                style={{ paddingTop: "30px", paddingBottom: "15px" }}
              >
                The Big Five
              </Typography>
              <Radar data={withAvailableBenchmark(TBFdata)} options={TBFOptions}> style={{ margin: "auto" }}</Radar>
            </div>
            <Grid container spacing={5} style={{ paddingTop: "30px" }}>
                <Grid item xs="12" sm="12">
                  <Typography gutterBottom>
                    {getResponse( 
                      "TheBigFive.Total",
                      resultSet.TheBigFive.Total
                    )}
                   
                  </Typography>
                </Grid>
              </Grid>
          </div>
        </Box>
      </div>
      <Footer />
    </div>
  );
}

export default ResultExtended;

